module.exports = __webpack_public_path__ + "img/revive-logo.bc2f69d8.png";